
//动态列自定义表格
export default {
  data() {
    return {
      columnData: [],
      tableDataSet: [],
      tableVisible: false,
      pagingColumnData: [],
      isShowTure: [],
      userColumnsData: [],
      columnJurisdiction: false,
      tableReload: true,
      reportName: 'QualityCheckSummaryInfo'
    }
  },
  computed: {
  },
  mounted() {
    this.columns()
  },
  methods: {
    columns(type) {
      this.loading = !type ? true : false
      this.$q.goods.columns({ params: { reportName: this.reportName } }).then(res => {
        this.isShowTure = res.data.userColumns.length ? res.data.userColumns.filter(v => v.isShow).map(v => v.displayName) : []
        this.userColumnsData = res.data.userColumns.length ? res.data.userColumns : []
        this.dynamicCustomColumn()
        if(!type) {
          this.onSearch()
        }
      });
    },
    closeAddForm() {
      this.tableVisible = false;
      this.columns(true)
    },
    confirm() {
      let data = []
      this.tableDataSet.forEach(v => {
        let freezeFlag = v.freezeLeft || v.freezeRight ? true : false
        data.push({
          displayName: v.displayName,
          columnName: v.columnName,
          displayWidth: parseInt(v.displayWidth),
          reportName: this.reportName,
          freezeFlag: freezeFlag,
          freezeType: freezeFlag && v.freezeLeft ? 'left' : freezeFlag && v.freezeRight ? 'right' : '',
          isShow: v.isShow
        })
      })
      this.$q.common.mergeColumns({ data: data }).then(res => {
        if (res.success) {
          this.$message.success('自定义配置成功')
          this.tableReload = false
          this.$nextTick(_ => {
            this.tableReload = true;
          });
          // this.columns()
        } else {
          this.$message.error('自定义配置失败')
        }
        this.closeAddForm()
      });
    },
    //动态列表格设置判断 
    dynamicCustomColumn(data) {
      this.columnData = []
      var data = [];
      var tableDataSet = []
      var columnData = this.userColumnsData.map(v => v.displayName)
      this.pagingColumnData.forEach((v) => {
        let index = columnData.indexOf(v.titleName)
        if (this.userColumnsData.length) { //用户配置返回
          if (columnData.indexOf(v.titleName) != -1) { //包含用户之前配置的列
            tableDataSet.push({
              displayName: this.userColumnsData[index].displayName,
              displayWidth: this.userColumnsData[index].displayWidthNum,
              freezeLeft: this.userColumnsData[index].freezeType == 'left' ? true : false,
              freezeRight: this.userColumnsData[index].freezeType == 'right' ? true : false,
              isShow: this.userColumnsData[index].isShow,
              columnName: this.userColumnsData[index].columnName
            })
            if (this.isShowTure.indexOf(v.titleName) == -1) {
              data.push({
                displayName: this.userColumnsData[index].displayName,
                columnName: this.userColumnsData[index].columnName,
                displayWidth: this.userColumnsData[index].displayWidth,
                sortable: v.sortable == 1 ? 'custom' : false,
                span: false,
                freezeType: this.userColumnsData[index].freezeType,
                fieldType: v.fieldType
              });
            }
          } else { //不包含使用分页返回的列
            tableDataSet.push({
              displayName: v.titleName,
              displayWidth: '100',
              freezeLeft: v.freezeType == 'left' ? true : false,
              freezeRight: v.freezeType == 'right' ? true : false,
              isShow: v.isShow,
              columnName: v.propertyName
            })
            if (this.isShowTure.indexOf(v.titleName) == -1) {
              data.push({
                displayName: v.titleName,
                columnName: v.propertyName,
                displayWidth: "100px",
                sortable: v.sortable == 1 ? 'custom' : false,
                span: false,
                freezeType: v.fixed == "1" ? "left" : false,
                fieldType: v.fieldType
              });
            }
          }
        } else {//用户为配置使用分页默认配置
          tableDataSet.push({
            displayName: v.titleName,
            displayWidth: '100',
            freezeLeft: v.freezeType == 'left' ? true : false,
            freezeRight: v.freezeType == 'right' ? true : false,
            isShow: v.isShow,
            columnName: v.propertyName
          })
          data.push({
            displayName: v.titleName,
            columnName: v.propertyName,
            displayWidth: "150px",
            sortable: v.sortable == 1 ? 'custom' : false,
            span: false,
            freezeType: v.fixed == "1" ? "left" : false,
            fieldType: v.fieldType
          });
        }
      });

      this.columnData = data
      this.tableDataSet = tableDataSet
    },
    customColumn(data) {
      var tableSetData = []
      if (data.userColumns.length) {
        tableSetData = data.userColumns
        data = data.userColumns.filter(v => !v.isShow)
      } else {
        tableSetData = data.sysColumns
        data = data.sysColumns
      }
      let columnData = []
      let list = []
      data.forEach(v => {
        columnData.push({
          displayName: v.displayName,
          columnName: v.columnName,
          displayWidth: v.displayWidth,
          sortable: v.sortable == 1 ? 'custom' : false,
          span: false,
          freezeType: v.freezeType,
          fieldType: v.fieldType
        })
      })
      tableSetData.forEach(v => {
        list.push({
          displayName: v.displayName,
          displayWidth: v.displayWidthNum,
          freezeLeft: v.freezeType == 'left' ? true : false,
          freezeRight: v.freezeType == 'right' ? true : false,
          isShow: v.isShow,
          columnName: v.columnName,
        })
      });
      this.tableDataSet = list
      this.columnData = columnData
      
    },
  }
}